module.exports = __webpack_public_path__ + "img/id.dbb48673.png";